export default function (...args)
{
	return {
		regex: /^(\d{8})$/,
		filter: /[]/g,
	};
}

